import React from "react";
import { Alerta, TipoAlerta, Form, CampoTexto, Botao, TipoBotao } from "@intechprev/componentes-web";

import { PageClean } from "..";
import { UsuarioService } from "../../services";
import { LoginEntidade } from "../../entidades";

import { Link } from "react-router-dom";

import { reCAPTCHA } from "../../helpers";
import ReCAPTCHA from "react-google-recaptcha";

import config from "./../../config.json";

interface Props {
  history?: any;
}

interface State {
  user: LoginEntidade,
  loading: boolean;
  mensagem: string;
  erro: string;
  cpf: string;
  dataNascimento: string;
  ReCAPTCHATokenV2: string;
  mostrarReCAPTCHA: boolean;
}

export class EsqueciSenha extends React.Component<Props, State> {

  private alert = React.createRef<Alerta>();
  private form = React.createRef<Form>();

  private recaptcha = new reCAPTCHA("esqueci_senha");

  constructor(props: Props) {
    super(props);

    this.state = {
      user: new LoginEntidade(),
      loading: false,
      mensagem: "",
      erro: "",
      cpf: "",
      dataNascimento: "",
      ReCAPTCHATokenV2: "",
      mostrarReCAPTCHA: false
    }
  }

  enviarSenha = async () => {
    try {
      var form = this.form.current;

      await this.alert.current.limparErros();
      await form.validar();

      if (this.state.cpf.length !== 11) {
        await this.alert.current.adicionarErro("Campo \"CPF\" inválido.");
        return;
      }

      if (form.isValido()) {
        let tempUser = this.state.user;
        tempUser.Cpf = this.state.cpf;
        tempUser.DataNascimento = this.dateFormat(this.state.dataNascimento);
        tempUser.ReCAPTCHATokenV2 = this.state.ReCAPTCHATokenV2;
        tempUser.ReCAPTCHATokenV3 = await this.recaptcha.getToken();
        tempUser.Origem = 1;
        await this.setState({ user: tempUser });
        var resultado = await UsuarioService.CriarAcesso(this.state.user);
        window.alert(resultado);
        console.log(resultado);
        await this.props.history.push("/");
      }

    } catch (err) {
      const mostrarReCAPTCHA = err.message.indexOf("401") > -1;
      this.setState({
        erro: (err.response ? (err.response.data) : err),
        mostrarReCAPTCHA,
        ReCAPTCHATokenV2: ""
      });
    }
  }

  dateFormat = (data: any) => {
    const tempData = data.split("/");
    return `${tempData[2]}-${tempData[1]}-${tempData[0]}`;
  }

  render() {
    return (
      <PageClean {...this.props}>
        <h4>Bem vindo ao portal da PREVIRB</h4>

        <h5>
          <b>Esqueci minha senha / Primeiro Acesso</b><br />
          <br />
          <small>Preencha as informações para que possamos gerar uma senha que será enviada para seu e-mail cadastrado na PREVIRB.</small>
        </h5>

        <Form ref={this.form}>

          <CampoTexto
            contexto={this}
            nome={"cpf"}
            valor={this.state.cpf}
            placeholder={"CPF (somente números)"}
            obrigatorio
          />

          <CampoTexto
            contexto={this}
            nome={"dataNascimento"}
            valor={this.state.dataNascimento}
            placeholder={"Data de Nascimento"}
            mascara={"99/99/9999"}
            obrigatorio
          />

          <Botao
            titulo={"Enviar Código de Validação"}
            tipo={TipoBotao.primary}
            block
            submit
            usaLoading
            onClick={this.enviarSenha}
          />

          <br />

          {this.state.mostrarReCAPTCHA &&
            <ReCAPTCHA
              sitekey={config.reCAPTCHA_site_key_v2}
              onChange={(value: any) => this.setState({ ReCAPTCHATokenV2: value })}
            />
          }

          <Alerta
            ref={this.alert}
            padraoFormulario
            tipo={TipoAlerta.danger}
            tamanho={"12"}
          />

          {this.state.erro !== "" && (
            <Alerta
              tipo={TipoAlerta.danger}
              mensagem={this.state.erro}
            />
          )}

          <div className="form-group">
            <Link className={"btn btn-link"} id={"login"} to={"/login"}>Voltar para o login</Link>
          </div>

        </Form>
      </PageClean>
    );
  }
}